import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from '../styles.module.css'
import { useFormik } from 'formik'
import { Input } from '../../../components/ModalInputs'
import * as Yup from 'yup'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import { createTypeOfDocument, updateTypeOfDocument } from '../../../actions/typesOfDocuments'
import CustomSelect from '../../../components/CustomSelect'
import { arrayForSelect } from '../../../utils/arrayForSelect'
import { DismissalEmployee, GrantingLeave, Incoming, Departure, Transfer, BusinessTrip, Recruitment, Graduation, TransferClassToClass, EncouragingStudents, PunishmentStudents, PunishmentEmployee, ReceptionOfEmployees, Expulsion } from './Tabs'
import { OrderContext } from '../../../utils/context'
import { getPersonnelList } from '../../../actions/personnel/personnel'
import { createOrderSpec, getSpecFields, getSpecsValues, updateOrderSpec } from '../../../actions/orders'
import moment from 'moment'

const validationSchema = {
  1: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
    mid: Yup.number().required('обязательное поле').moreThan(0, 'необходимо выбрать из списка'),
    string: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'), // на должность
    string2: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'), // испыт срок
    string3: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'), // ставка
    money: Yup.number().required('обязательное поле').positive("Пожалуйста, введите число больше 0").integer(),
    date: Yup.date().required('обязательное поле'),
    date2: Yup.date().required('обязательное поле').min(Yup.ref('date'), 'Начальная дата не может быть больше конечной'),
  }),
  2: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
    mid: Yup.number().required('обязательное поле').moreThan(0, 'необходимо выбрать из списка'),
    money: Yup.number().required('обязательное поле').positive("Пожалуйста, введите число больше 0"),
    money2: Yup.number().required('обязательное поле').positive("Пожалуйста, введите число больше 0"),
    money3: Yup.number().required('обязательное поле').positive("Пожалуйста, введите число больше 0"),
    date: Yup.date().required('обязательное поле'),
  }),
  3: Yup.object({
    string: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
    string2: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
    mid: Yup.number().required('обязательное поле').moreThan(0, 'необходимо выбрать из списка'),
    money: Yup.number().required('обязательное поле').positive("Пожалуйста, введите число больше 0"),
    date2: Yup.date().required('обязательное поле').min(Yup.ref('date'), 'Начальная дата не может быть больше конечной'),
    date: Yup.date().required('обязательное поле'),
  }),
  4: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  }),
  5: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  }),
  6: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  }),
  7: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  }),
  8: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  }),
  9: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  }),
  10: Yup.object({
    name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),
  }),

}

const bodySpec = {
  'idorderspectype': 1,
  "money": null,
  "money2": null,
  "money3": null,
  "string": "",
  "string2": "",
  "string3": "",
  "string4": "",
  "string5": "",
  "mid": 0,
  "name": "",
  'date': moment().format('YYYY-MM-DD'),
  'date2': moment().format('YYYY-MM-DD')
}

export default function ModalComponent({ data, closeModal, height, addMode, idorder }) {

  const dispatch = useDispatch()


  const { specFields, specTypesList, specValues, } = useSelector(state => state.orders)
  const { personnelList, } = useSelector((state) => state.personnel)

  const [mode, setMode] = useState(1)

  // вызываю учителей для большинства типов спецификации и передаю в контекст
  useEffect(() => {
    dispatch(getPersonnelList('Работает'))
    data.idorderspectype && setMode(data.idorderspectype)
  }, [])

  useEffect(() => {
    !addMode && specValues && setValues({ ...values, ...specValues })
  }, [specValues])

  useEffect(() => {
    mode && dispatch(getSpecFields(mode))
  }, [mode]);

  const handleCreate = (values) => {
    dispatch(createOrderSpec(idorder, values))
    closeModal()
    resetForm()
    resetData()
  }

  const handleUpdate = (values) => {
    dispatch(updateOrderSpec(values))
    closeModal()
    resetForm()
    resetData()
  }

  const resetData = () => setValues({});

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    setFieldValue,
    setValues,
    resetForm,
  } = useFormik({
    initialValues: addMode ? bodySpec : data,
    enableReinitialize: true,
    validateOnChange: true,
    validationSchema: validationSchema[mode],
    onSubmit: addMode ? handleCreate : handleUpdate
  })

  //выбор типа приказа
  useEffect(() => {
    values.idorderspectype && setMode(values.idorderspectype)
  }, [values.idorderspectype])

  useEffect(() => {
    !addMode && dispatch(getSpecsValues(values.idorderspec))
  }, [values.idorderspec])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  const renderTab = () => {
    switch (mode) {
      case 1: return <ReceptionOfEmployees /> // прием //
      case 2: return <DismissalEmployee /> // увольнение //
      case 3: return <GrantingLeave /> // отпуск //
      case 4: return <Incoming /> // прибытие // список студентов с выбором  //
      case 5: return <Departure /> // убытие // список студентов с выбором //
      case 6: return <Transfer /> // перевод //
      case 7: return <BusinessTrip /> // командировка // список перподов с выбором //
      case 8: return <Expulsion /> // Отчисление //
      case 9: return <Recruitment /> // Набор // // список студентов с выбором //
      case 10: return <Graduation /> //Выпуск //// список студентов с выбором //
      case 11: return <TransferClassToClass /> //Перевод в другой класс //// список студентов с выбором //
      case 12: return <EncouragingStudents /> //Поощрение студентов// список студентов с выбором //
      case 13: return <PunishmentStudents /> //взыскание// список студентов с выбором //
      case 14: return <PunishmentEmployee /> //взыскание// список перподов с выбором //
      default: return
    }
  }

  return (
    <Modal
      open={!!data}
      onClose={() => false}
      showCloseIcon={false}
      height={height}
      center
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal}  >
          <div className={styles.tabWrapper} >
            <div className={styles.inputsRow}>
              <CustomSelect
                title='Тип'
                valuesName="idorderspectype"
                options={arrayForSelect(specTypesList, 'name', 'idorderspectype')}
                // value={specTypesList && specTypesList?.find(item => item.idorderspectype == values.idorderspectype || item.idorderspectype == mode)?.name}
                value={values.idorderspectype}
                setFieldValue={setFieldValue}
                withoutAll
                width={300}
              />
            </div>

            <div className={styles.inputsRow}>
              <Input
                label='Название'
                name='name'
                value={values.name}
                // error={error('name')}
                onChange={handleChange}
                style={{ width: '600px' }}
              />
            </div>
            <OrderContext.Provider value={{ handleChange, closeModal, values, setFieldValue, error, personnelList, specFields, setValues }}>
              {renderTab()}
            </OrderContext.Provider>

          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
      </>
    </Modal>

  )
}
